import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';

import Image from '../components/post/image';
import Intro from '../components/post/intro';

const Post = ({ data }) => {
  const { post } = data.strapi;
  const { image } = post;
  return (
    <Wrapper>
      <Container extraSmall>
        <Intro {...post} />
        {post?.headTitle && (
          <StyledContent>
            <h1>{post.headTitle}</h1>
            {image && (
              <p>
                <Image
                  image={image}
                  alt={image.alternativeText || image.name}
                />
              </p>
            )}
          </StyledContent>
        )}
        <StyledContent $content={post.content} />
      </Container>
    </Wrapper>
  );
};

const StyledContent = styled(Content)`
  img {
    display: block;
    margin: 0 auto;
    width: calc(100% + ${({ theme }) => theme.grid.containerGap} + ${({ theme }) => theme.grid.containerGap});
    max-width: initial;
    margin-left: -${({ theme }) => theme.grid.containerGap};
    @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
      margin-left: 0;
      width: auto;
      max-width: 100%;
    }
  }
`;

const Wrapper = styled.div`
  padding: 3rem 0;
`;

export default (props) => (
  <Layout {...props.data.strapi.post}>
    <Post {...props} />
  </Layout>
);

export const pageQuery = graphql`
  fragment BlogPostsHead on STRAPI_BlogPosts {
    headTitle: title
    headSlug: slug
    headMetaDescription: metaDescription
    headImage: image {
      url # needed for projection
      src: url
      height
      width
      imageFile {
        childImageSharp {
          fixed {
            src
            height
            width
          }
        }
      }
    }
  }

  query BlogPostById($id: ID!) {
    strapi {
      post(id: $id) {
        id
        content
        date # projection for formattedDate
        formattedDate
        image {
          url # needed for projection
          src: url
          height
          width
          name
          alternativeText
          imageFile {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, width: 768, quality: 80, placeholder: BLURRED)
            }
          }
        }

        ...BlogPostsHead
      }
    }
  }
`;
